import React from "react";
import styles from "./styles.module.sass";
import { locations } from "../../constants";
import MailingList from "../MailingList";
import { slugify } from "../../helpers";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => (
  <div className={[styles.footer, className].filter(Boolean).join(" ")}>
    <div className={styles.footer__columns}>
      <div className={styles.column}>
        <h2>Discover All Lloyd’s Inn</h2>
        <ul>
          {locations.map((location: string) => (
            <li key={location} className={styles.footer__item}>
              {(location === "Singapore" || location === "Bali" || location === "Kuala Lumpur") && (
                <a href={`/${slugify(location.toLowerCase())}`}>{location}</a>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.column}>
        <MailingList pClass={styles.pClass} className={styles.mailing} />
      </div>
    </div>
    <div className={styles.liner}>
      2025 Copyright, Lloyd’s Inn
    </div>
  </div>
);

export default Footer;
